import { BlogArticle } from "../types";

export const blogArticles: Record<string, BlogArticle> = {
  "1": {
    blogId: "1",
    markdownFilePath: "/articles/1-clean-architecture.md",
  },
  "2": {
    blogId: "2",
    markdownFilePath: "/articles/2-state-management.md",
  },
  "3": {
    blogId: "3",
    markdownFilePath: "/articles/3-performance-optimization.md",
  },
  "4": {
    blogId: "4",
    markdownFilePath: "/articles/4-firebase-integration.md",
  },
  "5": {
    blogId: "5",
    markdownFilePath: "/articles/5-custom-animations.md",
  },
  "6": {
    blogId: "6",
    markdownFilePath: "/articles/6-testing-flutter-apps.md",
  },
  "7": {
    blogId: "7",
    markdownFilePath: "/articles/7-low-level-programming.md",
  },
  "8": {
    blogId: "8",
    markdownFilePath: "/articles/8-async-programming.md",
  },
  "9": {
    blogId: "9",
    markdownFilePath: "/articles/9-image-processing-basics.md",
  },
  "10": {
    blogId: "10",
    markdownFilePath: "/articles/10-file-structure-basics.md",
  },
  "11": {
    blogId: "11",
    markdownFilePath: "/articles/11-cpu-architecture.md",
  },
  "12": {
    blogId: "12",
    markdownFilePath: "/articles/12-dynamic-linking-ffi.md",
  },
  "13": {
    blogId: "13",
    markdownFilePath: "/articles/13-neovim-lsp.md",
  },
  "14": {
    blogId: "14",
    markdownFilePath: "/articles/14-docker-containerization.md",
  },
  "15": {
    blogId: "15",
    markdownFilePath: "/articles/15-github-actions.md",
  },
  "16": {
    blogId: "16",
    markdownFilePath: "/articles/16-internet-fundamentals.md",
  },
  "17": {
    blogId: "17",
    markdownFilePath: "/articles/17-shorebird-codepush.md",
  },
  "18": {
    blogId: "18",
    markdownFilePath: "/articles/18-dynamic-library-intro.md",
  },
  "19": {
    blogId: "19",
    markdownFilePath: "/articles/19-fourier-transform-series.md",
  },
  "20": {
    blogId: "20",
    markdownFilePath: "/articles/20-data-structures-basics.md",
  },
  "21": {
    blogId: "21",
    markdownFilePath: "/articles/21-syntax-comparison.md",
  },
};
